export default {
  type: 'groups',
  name: 'Group',
  permissions: {
    view: [
      { app: 'people', role: 'people' },
      { app: 'people', role: 'people_sys_admin' }
    ],
    insert: [
      { app: 'people', role: 'people' },
      {
        app: 'people',
        role: 'people_sys_admin',
        defaults: {
          groupTypeCode: 'System',
          roleName: 'org-2.2.5-adc-systems-administration'
        }
      }
    ],
    update: [
      { app: 'people', role: 'people' },
      {
        app: 'people',
        role: 'people_sys_admin',
        if: { field: 'groupTypeCode', value: 'System' }
      }
    ],
    delete: { app: 'people', role: 'people' }
  },
  search: {
    search: 'allGroups',
    orderBy: {
      type: 'GroupsOrderBy',
      default: 'GROUP_NAME_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        searchOnly: true
      },
      {
        name: 'groupName',
        searchable: false,
        order: 'GROUP_NAME'
      },
      {
        name: 'groupTitle',
        searchable: false,
        order: 'GROUP_TITLE'
      },
      {
        name: 'groupTypeCode',
        label: 'Group Type',
        order: 'GROUP_TYPE_CODE',
        type: 'select',
        options: {
          lookup: 'allGroupTypes',
          value: 'groupTypeCode',
          text: 'groupTypeDesc',
          allowNull: true,
          nullText: 'All'
        }
      },
      {
        alias: 'parentGroup',
        searchable: false,
        showResults: false,
        order: 'PARENT_GROUP',
        join: 'groupByParentGroup',
        fields: ['groupName'],
        searchType: 'form'
      },
      {
        alias: 'emailLists',
        searchable: false,
        join: 'groupEmailsByGroupId',
        nodes: true,
        fields: ['emailList']
      },
      {
        alias: 'members',
        searchable: false,
        join: 'groupPeopleByGroupId',
        fields: ['totalCount'],
        searchType: 'form'
      },
      {
        alias: 'roles',
        searchable: false,
        join: 'groupRolesByGroupId',
        fields: ['totalCount'],
        searchType: 'form'
      },
      {
        alias: 'owner',
        searchable: false,
        order: 'ROLE_NAME',
        join: 'roleByRoleName',
        fields: [
          'roleName',
          {
            join: 'rolePeopleByRoleName',
            nodes: true,
            fields: [
              {
                join: 'personByPersonId',
                fields: ['fullName']
              }
            ]
          }
        ]
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'groupId',
        type: 'Int',
        required: true
      },
      {
        field: 'groupName',
        required: true
      },
      'groupTitle',
      'groupDescription',
      'groupTypeCode',
      {
        field: 'parentGroup',
        type: 'Int'
      },
      'roleName',
      {
        field: 'associatedEmails',
        save: false
      }
    ],
    key: ['groupId'],
    input: 'group',
    create: 'createGroup',
    delete: 'deleteGroup',
    update: 'updateGroup'
  },
  load: {
    nodeId: 'group',
    key: 'groupByGroupId'
  },
  form: {
    createHeader: 'Create Group',
    editHeader: 'Edit Group ${groupId} - ${groupName}',
    printHeader: 'Group ${groupId} - ${groupName}',
    schema: [
      {
        name: 'groupName',
        labelWidth: 2,
        required: true
      },
      {
        name: 'groupTitle',
        labelWidth: 2
      },
      {
        name: 'groupDescription',
        labelWidth: 2,
        type: 'textarea'
      },
      {
        name: 'groupTypeCode',
        label: 'Group Type',
        labelWidth: 2,
        type: 'select',
        required: true,
        options: {
          allowNull: true,
          lookup: 'allGroupTypes',
          value: 'groupTypeCode',
          text: 'groupTypeDesc'
        },
        permissions: {
          insert: { app: 'people', role: 'people' },
          update: { app: 'people', role: 'people' }
        }
      },
      {
        name: 'parentGroup',
        labelWidth: 2,
        type: 'select',
        options: {
          allowNull: true,
          lookup: 'allGroups',
          value: 'groupId',
          text: 'groupName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'GroupsOrderBy',
              default: 'GROUP_NAME_ASC'
            }
          ]
        }
      },
      {
        name: 'roleName',
        labelWidth: 2,
        label: 'Owner Role',
        type: 'select',
        options: {
          allowNull: true,
          lookup: 'allRoles',
          value: 'roleName',
          text: 'roleName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'RolesOrderBy',
              default: 'ROLE_NAME_ASC'
            }
          ]
        },
        required: true,
        DISABLED_after: {
          text: 'New',
          tooltip: 'Create new role',
          action: 'new',
          options: {
            formType: 'roles'
          }
        },
        permissions: {
          insert: { app: 'people', role: 'people' },
          update: { app: 'people', role: 'people' }
        }
      },
      {
        name: 'ownerName',
        vModel: 'roleName',
        labelWidth: 2,
        readonly: true,
        disabled: true,
        type: 'select',
        options: {
          lookup: 'allRoles',
          value: 'roleName',
          text: 'members'
        }
      },
      {
        name: 'associatedEmails',
        labelWidth: 2,
        readonly: true,
        type: 'textarea'
      }
    ],
    audit: {
      lookup: 'allPersonAudits',
      orderBy: { type: 'PersonAuditsOrderBy', value: 'EVENT_TIME_ASC' },
      dbTableHeaders: [
        {
          value: 'group_people',
          header: 'Person:',
          headerField: 'personNameAccount'
        },
        { value: 'role_people', header: 'Role:', headerField: 'roleName' },
        {
          value: 'subscriber_people',
          header: 'Email List:',
          headerField: 'nameList'
        },
        {
          value: 'application_group',
          header: 'Application:',
          headerField: 'applicationName'
        }
      ]
    }
  },
  joinTables: [
    {
      label: 'Roles',
      export: true,
      removeLabel: 'Remove ${roleByRoleName.recordId} from this group?',
      lookup: 'allGroupRoles',
      join: 'roleByRoleName',
      fields: [
        {
          field: 'roleName',
          name: 'roleName',
          required: true
        },
        'roleTitle',
        'members',
        {
          field: 'roleName',
          alias: 'recordId',
          show: false
        }
      ],
      options: {
        label: 'Permisions',
        lookup: 'allGroupPostgraphiles',
        join: 'postgraphileRoleByPostgraphileId',
        idField: 'postgraphileId',
        nameField: 'postgraphileName',
        descField: 'postgraphileDesc',
        conditions: {
          allMembers: { type: 'Boolean', default: false }
        },
        params: [
          {
            field: 'orderBy',
            passArray: true,
            type: 'GroupPostgraphilesOrderBy',
            default:
              'POSTGRAPHILE_ROLE_BY_POSTGRAPHILE_ID__POSTGRAPHILE_NAME_ASC'
          }
        ],
        recordJoin: 'groupRolePostgraphilesByGroupIdAndRoleName',
        fields: [
          {
            join: 'groupPostgraphileByGroupIdAndPostgraphileId',
            fields: [
              {
                field: 'postgraphileId',
                type: 'Int',
                required: true
              }
            ]
          }
        ],
        create: 'createGroupRolePostgraphile',
        delete:
          'deleteGroupRolePostgraphileByGroupIdAndRoleNameAndPostgraphileId',
        input: 'groupRolePostgraphile'
      },
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'roles'
        },
        permissions: {
          view: { app: 'people', role: 'people' }
        }
      },
      create: 'createGroupRole',
      delete: 'deleteGroupRole',
      input: 'groupRole',
      formType: 'roles',
      multiHeader: 'Added ${roleName} to group'
    },
    {
      label: 'Members',
      export: true,
      removeLabel: 'Remove ${personByPersonId.fullName} from this group?',
      lookup: 'allGroupPeople',
      join: 'personByPersonId',
      readonly: { field: 'groupId', value: 139 },
      fields: [
        { field: 'personId', name: 'personId', type: 'Int', required: true },
        { name: 'fullName', label: 'Name' },
        'affiliation'
      ],
      options: {
        label: 'Permisions',
        lookup: 'allGroupPostgraphiles',
        join: 'postgraphileRoleByPostgraphileId',
        idField: 'postgraphileId',
        nameField: 'postgraphileName',
        descField: 'postgraphileDesc',
        conditions: {
          allMembers: { type: 'Boolean', default: false }
        },
        params: [
          {
            field: 'orderBy',
            passArray: true,
            type: 'GroupPostgraphilesOrderBy',
            default:
              'POSTGRAPHILE_ROLE_BY_POSTGRAPHILE_ID__POSTGRAPHILE_NAME_ASC'
          }
        ],
        recordJoin: 'groupPeoplePostgraphilesByGroupIdAndPersonId',
        fields: [
          {
            join: 'groupPostgraphileByGroupIdAndPostgraphileId',
            fields: [
              {
                field: 'postgraphileId',
                type: 'Int',
                required: true
              }
            ]
          }
        ],
        create: 'createGroupPeoplePostgraphile',
        delete:
          'deleteGroupPeoplePostgraphileByGroupIdAndPersonIdAndPostgraphileId',
        input: 'groupPeoplePostgraphile'
      },
      route: {
        name: 'personEdit'
      },
      searchFilters: {
        statusCode: {
          in: {
            type: 'StringArray',
            array: true,
            required: true,
            default: '["A", "F"]'
          }
        }
      },
      create: 'createGroupPerson',
      delete: 'deleteGroupPerson',
      input: 'groupPerson',
      formType: 'people',
      multiHeader: 'Added ${fullName} to group'
    },
    {
      label: 'Associated Applications',
      addLabel: 'Add Applicaiton',
      removeLabel: 'Remove ${applicationByApplicationId.name} from this group?',
      lookup: 'allApplicationGroups',
      join: 'applicationByApplicationId',
      fields: [
        {
          field: 'applicationId',
          type: 'Int',
          required: true,
          show: false
        },
        { field: 'applicationName', alias: 'name' },
        { field: 'applicationDesc', alias: 'description' },
        {
          field: 'applicationId',
          alias: 'recordId',
          show: false
        }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'applications'
        }
      },
      create: 'createApplicationGroup',
      delete: 'deleteApplicationGroup',
      input: 'applicationGroup',
      formType: 'applications',
      multiHeader: 'Added ${applicationName} to group',
      permissions: {
        insert: { app: 'people', role: 'people' },
        delete: { app: 'people', role: 'people' }
      }
    },
    {
      label: 'Postgraphile Permissions',
      lookup: 'allGroupPostgraphiles',
      hideIfEmpty: true,
      conditions: { allMembers: { type: 'Boolean', default: true } },
      join: 'postgraphileRoleByPostgraphileId',
      fields: [
        //'postgraphileApp',
        'postgraphileRole',
        { field: 'postgraphileName', alias: 'name' },
        { field: 'postgraphileDesc', alias: 'description' }
      ]
    }
  ]
}
